import { DateTime } from "luxon";
import { Typography } from "render/ui/presentation/Typography";

export function MonthName({ date }: { date: DateTime }) {
  return (
    <Typography variant="body-label-m">{date.toFormat("MMMM")}</Typography>
  );
}
